import { useState, useEffect } from 'react';
import { Grid, Card, CardContent } from '@mui/material';
import NotesChatList from 'src/pages/EnquiryNotes/NotesChatList';
import Breadcrumbs from '../BreadCrumb';
import request from 'src/utils/request';
import Moment from 'react-moment';
import data from '@iconify/icons-eva/trash-2-outline';

function AddNoteIndex() {
  const [selectedData, setSelectedData] = useState(null);
  const [tabValue, setTabValue] = useState(null);

  const getNotes = (url, type, id) => {
    // const route_array = window.location.pathname.split('/');
    // var href = window.location.href;
    //     var array = href.split('/');
    //     var id = array[array.length-1];;
    let reqData = {};
    if (type === 'enquiry') {
      reqData = {
        enquiryId: id
      };
    } else if (type === 'requirement') {
      reqData = {
        requirementId: id
      };
    } else {
      reqData = {
        enquiryId: id
      };
    }
    request({
      url: url,
      method: 'post',
      data: reqData
    }).then(
      (response) => {
        console.log(response.data);
        setSelectedData(response.data);
      },
      // eslint-disable-next-line
      (error) => {
        // setShowSnackBarAlert({
        //   status: true,
        //   type: 'error',
        //   message: error['message']
        // });
      }
    );
  };

  useEffect(() => {
    var href = window.location.href;
    var array = href.split('/');
    var typeSegment = array[array.length - 3];
    var enquiryId = array[array.length - 1];
    if (typeSegment === 'enquiries') {
      getNotes('enquiry/getEnquiryDetails', 'enquiry', enquiryId);
      setTabValue('enquiry');
    } else if (typeSegment === 'requirements') {
      getNotes('requirement/getRequirementDetails', 'requirement', enquiryId);
      setTabValue('requirement');
    } else {
      setTabValue('task');
    }
  }, [tabValue]);

  return (
    <Grid container mt={1} mb={1} ml={3} spacing={1}>
      <Breadcrumbs />
      <Grid container mt={1} mr={2} spacing={2} mb={1}>
        <Grid item md={12}>
          <Card>
            <CardContent>
              {/* {tabValue == 'enquiry' ? ( */}
              <b>Enquiry</b> : {selectedData ? selectedData.subject : null}{' '}
              &nbsp; | &nbsp;
              <b>Description</b> :{' '}
              {selectedData ? selectedData.description : null} &nbsp; | &nbsp;
              <b>Customer Name</b> :{' '}
              {selectedData ? selectedData.customer?.name : null}&nbsp; | &nbsp;
              <b>Email</b> :{' '}
              {selectedData ? selectedData.customer?.email : null}&nbsp; |
              &nbsp;
              <b>Phone</b> :{' '}
              {selectedData ? selectedData.customer?.phone : null}&nbsp; |
              &nbsp;
              <b>Date</b> : &nbsp;
              <Moment format="D/MMM/YYYY">
                {selectedData ? selectedData.createdAt : null}
              </Moment>
              {/* // ) : tabValue == 'requirement' ? (
              //   <>
              //     <b>Requirement</b> : {selectedData ? selectedData.title : null} &nbsp; | &nbsp;
              //     <b>Category</b> : {selectedData ? selectedData.category?.name : null} &nbsp; | &nbsp;
              //     <b>Customer Name</b> : {selectedData ? selectedData.customer?.name : null }&nbsp; | &nbsp;
              //     <b>Email</b> : {selectedData ? selectedData.customer?.email : null }&nbsp; | &nbsp;
              //     <b>Phone</b> : {selectedData ? selectedData.customer?.phone : null }&nbsp; | &nbsp;
              //     <b>Date</b> : &nbsp;
              //     <Moment format="D/MMM/YYYY">
              //       {selectedData ? selectedData.createdAt : null}
              //     </Moment>
              //   </>
              // ) : (
              //   <>Enquiry : {selectedData ? selectedData.subject : null}</>
              // )} */}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Grid item mt={3} xs={5}></Grid>
        <Grid item mt={3} xs={5}>
          <NotesChatList pageNoteType={selectedData} />
        </Grid>
      </Grid>
    </Grid>
  );
}

export default AddNoteIndex;
